import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Checkout from './components/Checkout';
import Confirmation from './components/Confirmation';
import Header from './components/Header';
import StatusBanner from './components/StatusBanner';
import CartSheet from './components/CartSheet';
import CartButton from './components/CartButton';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

const PublicLayout = ({ children }) => (
  <>
    <StatusBanner />
    <Header />
    {children}
    <CartSheet />
    <CartButton />
  </>
);

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-[#FAF8F5]">
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route
                path="/"
                element={
                  <PublicLayout>
                    <Home />
                  </PublicLayout>
                }
              />
              <Route
                path="/checkout"
                element={
                  <PublicLayout>
                    <Checkout />
                  </PublicLayout>
                }
              />
              <Route
                path="/confirmation/:orderId"
                element={
                  <PublicLayout>
                    <Confirmation />
                  </PublicLayout>
                }
              />
            </Routes>
            <Toaster position="top-center" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
